import { render } from "./UploadProcess.vue?vue&type=template&id=b798fa1e&scoped=true&ts=true"
import script from "./UploadProcess.vue?vue&type=script&lang=ts"
export * from "./UploadProcess.vue?vue&type=script&lang=ts"

import "./UploadProcess.vue?vue&type=style&index=0&id=b798fa1e&scoped=true&lang=css"

import exportComponent from "E:\\Project\\mc-cloud-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b798fa1e"]])

export default __exports__